import React from "react";
import { Popover } from "react-bootstrap";
import styled from "styled-components";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { FONT_CSS } from "../../../constants/design/fontSize";
import { BORDER_RADIUS, SPACING } from "../../../constants/design/spacing";
import { FONT_WEIGHT } from "../../../constants/design/fontWeight";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PopoverContainer = styled(Popover as React.ComponentType<any>)`
  .popover-arrow {
    display: none;
  }
  background: ${BACKGROUND_COLORS.tooltip};
  border: 1px solid ${BORDER_COLORS.two};
  border-radius: ${BORDER_RADIUS.five}px;
  padding: ${SPACING.three}px;
  max-width: 300px;
`;

export const Title = styled.div`
  ${FONT_CSS.header.eight}
  margin-bottom: ${SPACING.two}px;
`;

export const Explanation = styled.span`
  ${FONT_CSS.body.five}
  color: ${TEXT_COLORS.two};

  strong {
    font-weight: ${FONT_WEIGHT.normal};
    color: ${TEXT_COLORS.one};
  }
`;
